import { connect } from 'react-redux';

import { siteboardAction } from '../actions/defaultActions';
import { 
  SET_JOINED_SUBSCRIPTION_DIALOGUE_SHOWING, getSubscriptionOwnerId, userCanViewProject, SET_EDIT_PROJECT_DIALOGUE_ID, SET_PATH, SET_UNREAD_MESSAGES_DIALOGUE_OPEN,
} from '../actions/types';

import PopupWindow from './PopupWindow';
import PushButton from './PushButton';

// icon imports
import CircleCheckIcon from '../icons/circleCheckIcon';

const JustJoinedSubscriptionDialogueId = ({ _projects, _users, _userId, _subscriptions, _justJoinedSubscriptionDialogueId, siteboardAction }) => {

  const selectedSubscription = _subscriptions[_justJoinedSubscriptionDialogueId];
  if(!selectedSubscription) return <></>;

  const closeDialogue = () => {
    siteboardAction(SET_JOINED_SUBSCRIPTION_DIALOGUE_SHOWING, {subscriptionId: ''})
  };

  const subscriptionOwner = _users[getSubscriptionOwnerId(selectedSubscription)];
  const newProjects = [];
  for(const projectId in selectedSubscription.projectIds) {
    if(!(projectId in _projects)) continue;
    if(!userCanViewProject(_userId, selectedSubscription, _projects[projectId])) continue;
    newProjects.push(_projects[projectId]);
  }
  const userIsAccountManager = _userId in selectedSubscription.members && selectedSubscription.members[_userId].role === 'Admin';

  return (
    <>
      <PopupWindow title='Invite Accepted' closeDialogue={closeDialogue} bgStyle='bg-[#333333]'>
        <div className='flex flex-col gap-8 max-w-screen-sm text-white'>
          <div className='w-[90vw] max-w-full' />
          <div className='flex items-start gap-2 text-[1.2em] px-4'>
            <CircleCheckIcon size='1.4em' color='#00bc7d' />
            <div>You've joined <b>{subscriptionOwner.firstName} {subscriptionOwner.lastName}</b>'s account.</div>
          </div>
          <div className='flex flex-col gap-2'>
            <div className='flex flex-col gap-2 bg-[#222] p-6 rounded-lg'>
              <header className='text-[1.2em] font-bold'>New Projects</header>
              <div>You now have access to the following projects: </div>
              <ul className=''>
                {newProjects.map((project, index) => (
                  <li key={index} className='flex items-center text-gray-200'>
                    <button 
                      className='flex items-center gap-2 w-full text-left hover:bg-[#444] px-2 py-1 rounded-lg'
                      onClick={() => {
                        siteboardAction(SET_EDIT_PROJECT_DIALOGUE_ID, { projectId: project.id });
                      }}
                    >
                      <span className='w-2 min-w-2 h-2 min-h-2 rounded-full bg-[#fff]'></span>
                      <span>{project.name}</span>
                    </button>
                  </li>
                ))}
              </ul>
              <div className='flex flex-col gap-2 mt-4'>
                To view the 3-week schedule for these projects,
                <PushButton 
                  textColor='white'
                  bgColor='#471cff'
                  hoverBgColor='#603aff'
                  onClick={() => {
                    siteboardAction(SET_PATH, { path: 'projects' });
                    siteboardAction(SET_UNREAD_MESSAGES_DIALOGUE_OPEN, { isOpen: false });
                    closeDialogue();
                  }}
                >
                  Go To Projects
                </PushButton>
              </div>
            </div>
            {userIsAccountManager &&
              <div className='flex flex-col gap-2 bg-[#222] p-6 rounded-lg'>
                <header className='text-[1.2em] font-bold'>Account Manager Assignment</header>
                <div>You've been designated as an account manager for <b>{subscriptionOwner.firstName} {subscriptionOwner.lastName}</b>'s account. In this role, you have the authority to create and edit projects, and assign project members and admins to all projects within the account.</div>
              </div>
            }
          </div>
        </div>
      </PopupWindow>
    </>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  _projects: state.serverSynced.projects,
  _users: state.serverSynced.users,
  _userId: state.localPersistent.userId,
  _subscriptions: state.serverSynced.subscriptions,
  _justJoinedSubscriptionDialogueId: state.localEphemeral.justJoinedSubscriptionDialogueId,
}};
export default connect(mapStateToProps, { siteboardAction })(JustJoinedSubscriptionDialogueId);
